import { IString, ITableTree, TableTreeExpand } from '../model';

// 边距关系需要跟表格的大小有关系，后续会设计多种模式，小、中、大。每种模式的边距大小各不一致
const LEVEL_SPACING = 36; // 边距是 4px，按钮 32px, 所以默认有树关系为 36px
const LEVEL_SPACING_INCREMENTAL = 32; // 树递进关系，需要除去边距 4px，所以每次递增 32px

export const TREE_CHILDREN_KEY = 'children';

export const getTreeChildrenKey = (tree?: ITableTree) => {
  return tree?.key || TREE_CHILDREN_KEY;
};

export function isRowTreeRender<T>(
  dataItem: T,
  rowKey?: string,
  tree?: ITableTree
) {
  const item = dataItem as unknown as IString<any>;
  if (!rowKey || typeof item[rowKey] === 'undefined') {
    // log.error(`Please specify rowKey, which is required in tree data display. rowKey value: ${rowKey}`)
    return {
      isTree: false,
    };
  }

  const treeKey = getTreeChildrenKey(tree);
  if (!Array.isArray(item[treeKey])) {
    // log.error(`Children data must be an array. The resulting type is ${typeof item[treeKey]}`)
    return {
      isTree: false,
    };
  }

  return {
    isTree: true,
    children: item[treeKey] as ReadonlyArray<T>,
  };
}

export const isTreeExpand = (id: string, expandTree?: TableTreeExpand) => {
  if (!expandTree) {
    return false;
  }
  return !!expandTree[id];
};

export const getLevelSpacingStyle = (id: string) => {
  const level = id.split('-');
  if (level.length <= 1) {
    return {};
  }

  let spacing = LEVEL_SPACING;
  if (level.length > 2) {
    spacing += LEVEL_SPACING_INCREMENTAL * (level.length - 2);
  }
  const style: React.CSSProperties = {
    paddingLeft: `${spacing}px`,
  };
  return style;
};
